import { render, staticRenderFns } from "./ListBeneficiary.vue?vue&type=template&id=53252243&"
import script from "./ListBeneficiary.vue?vue&type=script&lang=js&"
export * from "./ListBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports